import React from 'react';
import { Box, Typography } from '@mui/material';
import ColorPalette from '../../../../colorpalette/ColorPalette';
import LessonRow from './LessonRow';
import { countCompleted } from '../useTutorialProgress';
import styles from '../Tutorials.module.css';

/**
 * Lista de lições de um capítulo (atalho "Como usar esta tela").
 * @param {Object} chapter - { title, description }
 * @param {Array} lessons - [{ id, number, title }]
 * @param {Number} currentIndex
 * @param {Function} onSelect - recebe o índice da lição
 * @param {Object} progressById - progresso por id da lição (opcional; sem ele a lista não mostra o que foi assistido)
 */
const LessonList = ({ chapter, lessons, currentIndex, onSelect, progressById = null }) => (
  <Box className={styles.lessonList}>
    <Box sx={{ mb: 1.5, px: 0.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
        <Typography sx={{ fontWeight: 700, color: '#1A1A2E', fontSize: '1rem' }}>
          {chapter?.title || 'Neste capítulo'}
        </Typography>
        <Typography sx={{ color: ColorPalette.textLight, fontSize: '0.8rem' }}>
          {progressById
            ? `${countCompleted(lessons, progressById)} de ${lessons.length} assistidas`
            : `${lessons.length} ${lessons.length === 1 ? 'lição' : 'lições'}`}
        </Typography>
      </Box>
      {chapter?.description && (
        <Typography sx={{ color: ColorPalette.textLight, fontSize: '0.82rem', lineHeight: 1.45, mt: 0.5 }}>
          {chapter.description}
        </Typography>
      )}
    </Box>

    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      {lessons.map((lesson, index) => (
        <LessonRow
          key={lesson.id}
          lesson={lesson}
          index={index}
          selected={index === currentIndex}
          progress={progressById ? progressById[lesson.id] : null}
          onClick={() => onSelect(index)}
        />
      ))}
    </Box>
  </Box>
);

export default LessonList;
